import { render, staticRenderFns } from "./DiseaseTracking.vue?vue&type=template&id=959e5c8e&scoped=true&"
import script from "./DiseaseTracking.vue?vue&type=script&lang=js&"
export * from "./DiseaseTracking.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseTracking.vue?vue&type=style&index=0&id=959e5c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959e5c8e",
  null
  
)

export default component.exports